import { FC, ReactNode } from 'react'
import { ComplementaryItemAvatar, ComplementaryItemAvatarType } from './Avatar'
import {
  ComplementaryItemSpinner,
  ComplementaryItemSpinnerType,
} from './Spinner'

const ComplementaryItem: FC &
  ComplementaryItemAvatarType &
  ComplementaryItemSpinnerType = (): ReactNode => <></>

ComplementaryItem.Avatar = ComplementaryItemAvatar
ComplementaryItem.Spinner = ComplementaryItemSpinner

export default ComplementaryItem
